
import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import "../../assets/css/Expenselist.css";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

import Select from "react-select";
import styled from "styled-components";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import ActionsDropdown from "../ActionsDropdown";


const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(odd) {
    background-color: #f2f2f2; /* Light gray for even rows */
  }

  tr:nth-child(even) {
    background-color: #ffffff; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};





function Expenselist() {
  const [responseData, setResponseData] = useState([]);
  const [responseDatas, setResponseDatas] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isUpdateshowModal, setUpdateShowModal] = useState(false);
  const [ispreviewshowModal, setpreviewShowModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [branch, setbranch] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [officeexpense, setOfficeexpense] = useState([]);
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  const [paymenttype, setpaymenttype] = useState([]);
  // current date//////////////////////////////
  const formatDate = (date) => {
    if (!(date instanceof Date)) {
      date = new Date(date); // Convert input to Date if it's not already
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDatefitching = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };


  useEffect(() => {
    fetchData();

  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl + "/expense_list", {
        params: { data: localStorage.getItem("branch_id") }
      });
      console.log("Response from server:", response.data);


      if (response && response.status === 200) {
        setTimeout(() => {
          setLoading(false);
        }, 300);
      }

      setResponseData(response.data.reverse());
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [updateData, setUpdateData] = useState({
    branch_id: "",
    type: "",
    date: formatDate(new Date()),
    notes: "",
    expense_type: "",
    amount: "",
    from: "",
    paidto: "",
    paytype: "",
  });






  useEffect(() => {
    fetchDatas();
    fetchDataed();
    gettoken();
    fetchVendorDetails();
    paymenttyperoute();
    fetchExpenseDetails();
    getprevillages();
  }, []);
  const fetchDatas = async () => {
    try {
      const response = await axios.get(apiUrl + "/expense_type");
      console.log("Response from server type:", response.data);
      setResponseDatas(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetchDataed = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      console.log("Response from server:", response.data);
      setbranch(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const paymenttyperoute = async () => {
    try {
      const response = await axios.get(apiUrl + "/paytype");
      console.log("Response from server:", response.data);
      setpaymenttype(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetchExpenseDetails = async () => {
    try {
      const response = await axios.get(apiUrl + "/Officeexpense");
      console.log("Response from expense_details API:", response.data);
      setOfficeexpense(response.data); // Set office expense data
    } catch (error) {
      console.error("Error fetching office expense data:", error.message);
    }
  };

  // Function to fetch vendor details
  const fetchVendorDetails = async () => {
    try {
      const response = await axios.get(apiUrl + "/vendar_details");
      console.log("Response from vendar_details API:", response.data);
      setVendor(response.data); // Set vendor data
    } catch (error) {
      console.error("Error fetching vendor data:", error.message);
    }
  };

  const gettoken = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);

      setroleid(response.data.detail.rolename);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      if (id) {
        // try {
        //   const response = await axios.get(apiUrl + `/role_2/${id}`);

        //   const modules = response.data.modules;

        //   const filtered_access = modules.filter(
        //     (item) => item.name == "Branch"
        //   );

        //   setprevillages(filtered_access[0].actions);
        // } catch (error) {
        //   console.error("Error fetching data:", error.message);
        // }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);
    const total_previlages = username.modules;
    const new_enquiry = total_previlages.find((item) => item.name == "Expense List")
    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions)
  }




  const [updateid, setUpdateId] = useState("");

  const handleUpdate = (_id, data) => {
    if (previllages.edit || previllages.all) {
      setUpdateId(_id);

      const date = new Date(data.date);
      if (isNaN(date)) {
        console.error("Invalid date:", data.date);
        return;
      }
      setUpdateShowModal(true);
      const formattedDate = date.toLocaleDateString("en-CA");
      console.log("the data type ", data);
      setUpdateData({
        // branch_id: data.branch_id[0]._id,
        // branch_name: data.branch_id[0].branch_name,
        branch_name: data.branch,
        branch_id: data.branch_id,
        type: data.type,
        // type: data.type[0]._id,
        type: data.type,

        date: formattedDate,
        expense_type: data.expense_type,
        notes: data.notes,
        amount: data.amount,
        from: data.from,
        paidto: data.paidto,
        paytype: data.paytype,
      });
    } else {
      toast.error("You don't have the permission to update");
    }
  };

  const handlepreview = (_id, data) => {

    setUpdateId(_id);

    const date = new Date(data.date);
    if (isNaN(date)) {
      console.error("Invalid date:", data.date);
      return;
    }
    setpreviewShowModal(true);
    const formattedDate = date.toLocaleDateString("en-CA");
    console.log("the data type ", data);
    setUpdateData({
      // branch_id: data.branch_id[0]._id,
      // branch_name: data.branch_id[0].branch_name,
      branch_name: data.branch,
      branch_id: data.branch_id,
      type: data.type,
      // type: data.type[0]._id,
      type: data.type,

      date: formattedDate,
      expense_type: data.expense_type,
      notes: data.notes,
      amount: data.amount,
      from: data.from,
      paidto: data.paidto,
      paytype: data.paytype,
    });

  };



  const kk = (_id, data) => {
    setUpdateId(_id);
    const dated = new Date(data.date);
    if (isNaN(dated)) {
      console.error("Invalid date:", data.date);
      return;
    }

    setpreviewShowModal(true);

    const formattedDate = dated.toLocaleDateString("en-CA");
    console.log("the data type ", data);
    setUpdateData({
      branch_id: data.branch_id[0]._id,
      branch_name: data.branch_id[0].branch_name,
      type: data.type[0]._id,
      type: data.type.length != 0 ? data.type[0].type : "-",
      // type: data.type,
      date: formattedDate,
      expense_type: data.expense_type,
      notes: data.notes,
      amount: data.amount,
      from: data.from,
      paidto: data.paidto,
      paytype: data.paytype,

    });

  };




  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        branch_id: updateData.branch_id,
        // type: updateData.type[0]._id
        type: updateData.type,
        // type: updateData.type.length != 0 ? updateData.type[0].type : "-",
        date: updateData.date,
        notes: updateData.notes,
        expense_type: updateData.expense_type,
        amount: updateData.amount,
        from: updateData.from,
        paidto: updateData.paidto,
        paytype: updateData.paytype,

      };
      console.log("the update submit data", formData);
      const response = await axios.put(
        apiUrl + `/expense_list/${updateid}`,
        formData
      );
      console.log("response for update", response);
      setUpdateShowModal(false);
      toast.success("Update successfully!");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const handleDelete = async (_id) => {
    try {
      setLoading(true);
      await axios.delete(apiUrl + `/expense_list/${getdeleteid}`);
      toast.error("Delete successfully!");
      setDeleteShowModals(false);
      fetchData();
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error deleting role:", error.message);
    }
  };

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };




  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const handleOpenModal = (_id, paidto) => {
    if (previllages.all || previllages.delete) {
      console.log(" the id", _id);
      console.log(" the name", paidto);
      setdeleteid(_id);
      setdeletename(paidto);
      setDeleteShowModals(true);
    } else {
      toast.error("You don't have the permission");
    }
  };

  // the pagination ---------------------------------------------------------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Search
  const filtered = currentItems.filter((item) =>
    Object.values(item).some(
      (value) =>
        (typeof value === "string" &&
          value.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (typeof value === "number" && value.toString().includes(searchQuery))
    )
  );

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(responseData.length / itemsPerPage);

  const goToNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage === totalPages ? prevPage : prevPage + 1
    );
  };

  const goToPrevPage = () => {
    setCurrentPage((prevPage) => (prevPage === 1 ? prevPage : prevPage - 1));
  };
  // the pagination  end ---------------------------------------------------------------------


  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`} key="prev">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === 0 ? "active" : ""}`} key={0}>
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === 1 ? "active" : ""}`} key={1}>
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 3, currentPage + 1); i++) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 2 ? "active" : ""}`} key={totalPages - 2}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 2)}>
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 1 ? "active" : ""}`} key={totalPages - 1}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 1)}>
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };




  // ===========================================
  const navigate = useNavigate();

  const handleExpenseType = () => {
    navigate("/expensetype");
  };

  const [addData, setAddData] = useState({
    branch_id: "",
    type: "",
    date: "",
    notes: "",
    expense_type: "",
    amount: "",
    from: "",
    paidto: "",
    paytype: "",
  });

  const handleDateChange = (e) => {
    setUpdateData((prevData) => ({
      ...prevData,
      date: e.target.value, // Input type=date handles the format
    }));
  };

  const handlesubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const formData = {
        branch_id: addData.branch_id,
        type: addData.type ? addData.type : "",
        date: addData.date,
        notes: addData.notes,
        expense_type: addData.expense_type,
        amount: addData.amount,
        from: addData.from,
        paidto: addData.paidto,
        paytype: addData.paytype,
      };

      const response = await axios.post(apiUrl + "/expense_list", formData);
      console.log("Added:", response);

      // Reset the form and close the modal
      setShowModal(false);
      toast.success("Added successfully!");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData(); // Fetch updated data
      setAddData({
        branch_id: "",
        type: "",
        date: "",
        expense_type: "",
        notes: "",
        amount: "",
        from: "",
        paidto: "",
        paytype: "",
      });
    } catch (error) {
      console.error("Error adding data:", error.message);
      toast.error("Failed to add expense!"); // Optionally show error message
    }
  };

  useEffect(() => {
    if (addData.expense_type === "Office expense") {
      fetchExpenseDetails(); // Fetch office expenses
    } else if (addData.expense_type === "Vendor expense") {
      fetchVendorDetails(); // Fetch vendor details
    }
  }, [addData.expense_type]);

  useEffect(() => {
    if (updateData.expense_type === "Office expense") {
      fetchExpenseDetails(); // Fetch office expenses
    } else if (updateData.expense_type === "Vendor expense") {
      fetchVendorDetails(); // Fetch vendor details
    }
  }, [updateData.expense_type]); // Re-run whenever `expense_type` changes





  const [rolename, setrolename] = useState([]);
  useEffect(() => {

    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);

  const [loading, setLoading] = useState(false)

  const data = useMemo(() => {
    return responseData.map((item) => ({
      _id: item._id,
      branch: item.branch_id[0]?.branch_name,
      branch_id: item.branch_id[0]?._id,


      type: item.type[0]?._id,
      type_id: item.type.length != 0 ? item.type[0]?.type : "-",
      expense_type: item.expense_type,
      paidto: item.paidto,
      date: item.date,
      amount: item.amount,
      paytype: item.paytype,

      notes: item.notes,
      type_main: item.type[0] ? item.type[0].type : "-",
      // name:item.name

    }));
  }, [responseData]);

  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        id: "serialNo",
        Cell: ({ row }) => {
          return row.index + 1;
        },
      },


      {
        Header: "Branch",
        accessor: "branch",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Type",
        accessor: "type_id",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Expense type",
        accessor: "expense_type",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Paid To",
        accessor: "paidto",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Date",
        accessor: "date",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => {
          const date = new Date(value);  // Convert the ISO string to a Date object
          const day = String(date.getDate()).padStart(2, '0');  // Add leading zero if necessary
          const month = String(date.getMonth() + 1).padStart(2, '0');  // Get the month (zero-indexed, so add 1)
          const year = date.getFullYear();

          return `${day}-${month}-${year}`;  // Return the formatted date
        }
      },
      {
        Header: "Amount",
        accessor: "amount",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Pay Type",
        accessor: "paytype",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 5 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );






  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-1">
            <div className="col-lg-9">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>
              <Link to="" className="text-danger dashBoard_text">
                <b>Expense List</b>
              </Link>
              {/* <Link to="" className="text-danger dashBoard_text">
                            <b>Profile</b>
                        </Link> */}
            </div>
            <div className="col-lg-3 d-flex justify-content-end">
              <button className="btn btn-secondary" onClick={handleExpenseType}>
                Expense Type
              </button>
            </div>
          </div>
        </div>

        {/* <div className="row">
          <div className="col-lg-10">
            
          </div>
          
        </div> */}

        {/* ------------ search and per page ----------------------------*/}

        {/* <div className="mb-3 mt-3">
        <div className="row">
          <div className="col-lg-2 col-md-4 col-sm-4 d-flex">
            <label className="form-label text-dark mt-2">Show : </label>
            <div>
              <select
                className="form-control w-100 mx-2"
                onChange={(e) => {
                  setItemsPerPage(e.target.value);
                }}
              >
             
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>
            </div>
          </div>
          <div className="col-lg-7 col-md-4 col-sm-1"></div>
          <div className="col-lg-3 col-md-4 col-sm-7">
            <div className="w-full flex-1">
              <form>
                <div className="relative">
                  <input
                    className="form-control w-full bg-white  appearance-none pl-8  dark:bg-gray-950"
                    placeholder="Search ..."
                    type="search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div> */}
        {/* --------------------------------end------------------------------------------- */}




        <div className="mb-3 mt-3">
          <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-1">
              <div className="d-flex">
                <h5 className="mt-1">Expense List</h5>
                <div className="mx-3">
                  {previllages.add && (
                    <button className="btn add" onClick={() => setShowModal(true)}>
                      Add
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end">

              {/* </div>

            <div className="col-lg-3 col-md-4 col-sm-7"> */}
              <div className="w-full flex-1 me-5">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={state.globalFilter || ""} // Use the globalFilter value
                      onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                    />
                  </div>
                </form>
              </div>
              <div className="d-flex me-2">
                <label className="form-label text-dark mt-1">Show : </label>
                <div>
                  <select
                    className="form-control w-100 mx-2"
                    value={state.pageSize}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'All') {
                        setPageSize(data.length);  // 'data' should be your dataset containing all the entries
                      } else {
                        setPageSize(Number(value));
                      }
                    }}
                  >
                    <option value="All">All</option> {/* Add 'All' option */}
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>



        {/* <div className="card">
        <div className="mt-1">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>S.No</th>
                {rolename === "Branches" && (<th>Branch</th>)}
                <th>Expense Type</th>
                <th>Type</th>
                <th>Paid To</th>
                <th>Date</th>
                <th>Amount</th>
                <th>Pay Type</th>
                <th className="text-center action">Action</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>

                  {rolename === "Branches" && (
                    <td>{item.branch_id[0].branch_name}</td>
                  )}



                  <td>{item.expense_type}</td>
                  <td>{item.type[0] ? item.type[0].type : "-"}</td>
                
                  <td>{item.paidto}</td>
                  <td>{formatDatefitching(item.date)}</td>
               
                  <td>{item.amount}</td>
                  <td>{item.paytype}</td>
                  <td className="text-center">
                    {previllages.edit && (
                      <button
                        className="btn updelete mx-2"
                        onClick={() => handleUpdate(item._id, item)}
                      >
                        <i class="fa-solid fa-pen-to-square"></i>
                      </button>
                    )}
                    {previllages.delete && (
                      <button
                        className="btn delete"
                        onClick={() => handleOpenModal(item._id, item.notes)}
                      >
                        <i class="fa-solid fa-trash-can"></i>
                      </button>
                    )}

                    <button
                      className="btn delete"
                      onClick={() => handlepreview(item._id, item)}
                    >
                      <i class="fa-solid fa-circle-info"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table> */}

        {/*           
        </div>
      </div> */}




        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex">
                      <div className="mx-2">{column.render("Header")}</div>
                      <div>
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                      <div className="mx-1">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </div>
                    </div>
                  </Th>
                ))}
                <Th className="text-center">Action</Th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  ))}
                  <Td className="text-center">
                    <ActionsDropdown
                      row={row.original}
                      permissions={{
                        edit: previllages.edit,
                        delete: previllages.delete,
                      }}
                      onEdit={(id, row) =>
                        handleUpdate(id, row)
                      }
                      onDelete={(id, row) =>
                        handleOpenModal(id, row.paidto)
                      }
                      onInfo={(id, row) =>
                        handlepreview(id, row)
                      }
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>












        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          className="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Add Expense List</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={addData.branch_id}
                      onChange={(e) =>
                        setAddData({ ...addData, branch_id: e.target.value })
                      }
                      required
                    >
                      <option value="">Select Branch</option>
                      {branch.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.branch_name}
                        </option>
                      ))}
                    </select>
                    <label className={addData.branch_id ? "filled" : ""}>
                      Select Branch
                    </label>

                  </div>

                  <div className="floating-label">
                    <label className="form-label">
                      <b></b>
                    </label>
                    <select
                      className="form-control"
                      value={addData.expense_type}
                      onChange={(e) =>
                        setAddData({ ...addData, expense_type: e.target.value })
                      }
                    >
                      <option value="">Expense type</option>
                      <option value="Office expense">Office expense</option>
                      <option value="Vendor expense">Vendor expense</option>
                    </select>
                    <label className={addData.expense_type ? "filled" : ""}>
                      Expense type
                    </label>
                  </div>

                  {/* {addData.expense_type === "Office expense"   &&      (
                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={addData.type}
                      onChange={(e) =>
                        setAddData({ ...addData, type: e.target.value })
                      }
                    >
                      <option value="">Select Type</option>
                      {responseDatas.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.type}
                        </option>
                      ))}
                    </select>
                    <label className={addData.type ? "filled" : ""}>
                      Select Type
                    </label>
                  </div>
                )} */}



                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={addData.type}
                      onChange={(e) =>
                        setAddData({ ...addData, type: e.target.value })
                      }
                    >
                      <option value="">Select Type</option>
                      {responseDatas.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.type}
                        </option>
                      ))}
                    </select>
                    <label className={addData.type ? "filled" : ""}>
                      Select Type
                    </label>
                  </div>




                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={addData.paidto}
                      onChange={(e) =>
                        setAddData({ ...addData, paidto: e.target.value })
                      }
                      required
                    >
                      <option value="" disabled>
                        {" "}
                        Select{" "}
                        {addData.expense_type === "Office expense"
                          ? "Office"
                          : "Vendor"}
                      </option>

                      {addData.expense_type === "Office expense" &&
                        officeexpense.map((item, index) => (
                          <option key={index} value={item.name}>
                            {item.name}
                          </option>
                        ))}

                      {addData.expense_type === "Vendor expense" &&
                        vendor.map((item, index) => (
                          <option key={index} value={item.name}>
                            {item.name}
                          </option>
                        ))}
                    </select>


                    <label className={addData.paidto ? "filled" : ""}>
                      Select paid To
                    </label>
                  </div>

                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">


                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      value={addData.date}
                      // onChange={handleDateChange}
                      onChange={(e) =>
                        setAddData({ ...addData, date: e.target.value })
                      }
                      required
                    />
                    <label className={addData.date ? "filled" : ""}>Date</label>
                    {/* {errors.date && (
                    <div className="error-text">{errors.date}</div>
                  )} */}
                  </div>



                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="number"
                      value={addData.amount}
                      onChange={(e) =>
                        setAddData({ ...addData, amount: e.target.value })
                      }
                      required
                    />
                    <label className={addData.amount ? "filled" : ""}>
                      Amount
                    </label>
                    {/* {errors.amount && (
                    <div className="error-text">{errors.amount}</div>
                  )} */}
                  </div>

                  {/* Paid To Dropdown */}

                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={addData.paytype}
                      onChange={(e) =>
                        setAddData({ ...addData, paytype: e.target.value })
                      }
                    >
                      <option value="">Select Paytype </option>
                      {paymenttype.map((item, index) => (
                        <option key={index} value={item.Payment_type}>
                          {item.Payment_type}
                        </option>
                      ))}
                    </select>
                    <label className={addData.paytype ? "filled" : ""}></label>
                    {/* {errors.paytype && (
                    <div className="error-text">{errors.paytype}</div>
                  )} */}
                  </div>
                </div>
              </div>
              <div className="floating-label col-lg-12">
                <input
                  className="form-control"
                  type="text"
                  value={addData.notes}
                  onChange={(e) =>
                    setAddData({ ...addData, notes: e.target.value })
                  }
                  required
                />
                <label className={addData.notes ? "filled" : ""}>Notes</label>
                {/* {errors.notes && (
                    <div className="error-text">{errors.notes}</div>
                  )} */}
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handlesubmit}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={isUpdateshowModal}
          onHide={() => setUpdateShowModal(false)}
          className="custom-modal"
        >





          <Modal.Header closeButton>
            <Modal.Title id="modeti">Update Expense list</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  {/* Other input fields */}

                  {/* <div className="floating-label">
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={updateData.branch_name}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          branch_id: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.branch_id ? "filled" : ""}>
                      Branch
                    </label>
                  </div> */}


                  <div className="floating-label">
                    <select className="form-select" value={updateData.branch_id} onChange={(e) => setUpdateData({ ...updateData, branch_id: e.target.value })}>
                      <option value="" disabled>Select Branch </option>
                      {branch.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.branch_id} - {item.branch_name}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.branch_id ? "filled" : ""}>

                    </label>

                  </div>

                  <div className="floating-label">
                    <label className="form-label">
                      <b></b>
                    </label>
                    <select
                      className="form-control"
                      value={updateData.expense_type}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          expense_type: e.target.value,
                        })
                      }
                    >
                      <option value="">Expense type</option>
                      <option value="Office expense">Office expense</option>
                      <option value="Vendor expense">Vendor expense</option>
                    </select>
                    <label className={updateData.expense_type ? "filled" : ""}>
                      Expense type
                    </label>
                  </div>

                  {/* {updateData.expense_type === "Office expense" && (
                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.type}
                      placeholder=""
                      onChange={(e) =>
                        setUpdateData({ ...updateData, type: e.target.value })
                      }
                    >

                      {responseDatas.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.type}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.type ? "filled" : ""}>
                      Type
                    </label>
                  </div>
                )} */}

                  {console.log("the console data type ", updateData.type)}

                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.type}
                      placeholder=""
                      onChange={(e) =>
                        setUpdateData({ ...updateData, type: e.target.value })
                      }
                    >

                      {responseDatas.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.type}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.type ? "filled" : ""}>

                    </label>
                  </div>







                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.paidto}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, paidto: e.target.value })
                      }
                      required
                    >
                      {/* <option value="">Select Name</option> */}
                      <option value="">
                        Select{" "}
                        {updateData.expense_type === "Office expense"
                          ? "Office"
                          : "Vendor"}
                      </option>
                      {/* Render options based on selected expense_type */}
                      {updateData.expense_type === "Office expense" &&
                        officeexpense.map((item, index) => (
                          <option key={index} value={item.name}>
                            {item.name}
                          </option>
                        ))}
                      {updateData.expense_type === "Vendor expense" &&
                        vendor.map((item, index) => (
                          <option key={index} value={item.name}>
                            {item.name}
                          </option>
                        ))}
                    </select>
                    <label className={updateData.paidto ? "filled" : ""}>
                      {/* Optionally you can add custom label text */}
                    </label>
                  </div>


                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">



                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      value={updateData.date}
                      onChange={handleDateChange}
                      required
                    />
                    <label className={updateData.date ? "filled" : ""}>
                      Date
                    </label>
                  </div>



                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.amount}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, amount: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.amount ? "filled" : ""}>
                      Amount
                    </label>
                  </div>

                  <div className="floating-label">
                    <select
                      className="form-control"
                      value={updateData.paytype}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, paytype: e.target.value })
                      }
                    >
                      <option value="">Select Paytype </option>
                      {paymenttype.map((item, index) => (
                        <option key={index} value={item.Payment_type}>
                          {item.Payment_type}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.paytype ? "filled" : ""}></label>
                  </div>
                </div>
              </div>
              <div className="floating-label col-lg-12">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.notes}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, notes: e.target.value })
                  }
                  required
                />
                <label className={updateData.notes ? "filled" : ""}>
                  Notes
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleupdatesubmit}
            >
              Update
            </Button>
          </Modal.Footer>
        </Modal>





        {/* ============================================================================================================ */}

        <Modal
          show={ispreviewshowModal}
          onHide={() => setpreviewShowModal(false)}
          className="custom-modal"
        >

          <Modal.Header closeButton>
            <Modal.Title id="modeti">Preview Expense</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  {/* Other input fields */}

                  <div className="floating-label">
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      disabled
                      value={updateData.branch_name}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          branch_id: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.branch_id ? "filled" : ""}>
                      Branch
                    </label>
                  </div>

                  <div className="floating-label">
                    <label className="form-label">
                      <b></b>
                    </label>
                    <select
                      className="form-control"
                      value={updateData.expense_type}
                      disabled
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          expense_type: e.target.value,
                        })
                      }
                    >
                      <option value="">Expense type</option>
                      <option value="Office expense">Office expense</option>
                      <option value="Vendor expense">Vendor expense</option>
                    </select>
                    <label className={updateData.expense_type ? "filled" : ""}>
                      Expense type
                    </label>
                  </div>

                  {/* {updateData.expense_type === "Office expense" && (
                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.type}
                      placeholder=""
                      onChange={(e) =>
                        setUpdateData({ ...updateData, type: e.target.value })
                      }
                    >

                      {responseDatas.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.type}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.type ? "filled" : ""}>
                      Type
                    </label>
                  </div>
                )} */}

                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.type}
                      placeholder=""
                      disabled
                      onChange={(e) =>
                        setUpdateData({ ...updateData, type: e.target.value })
                      }
                    >

                      {responseDatas.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.type}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.type ? "filled" : ""}>

                    </label>
                  </div>







                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.paidto}
                      disabled
                      onChange={(e) =>
                        setUpdateData({ ...updateData, paidto: e.target.value })
                      }
                      required
                    >
                      {/* <option value="">Select Name</option> */}
                      <option value="">
                        Select{" "}
                        {updateData.expense_type === "Office expense"
                          ? "Office"
                          : "Vendor"}
                      </option>
                      {/* Render options based on selected expense_type */}
                      {updateData.expense_type === "Office expense" &&
                        officeexpense.map((item, index) => (
                          <option key={index} value={item.name}>
                            {item.name}
                          </option>
                        ))}
                      {updateData.expense_type === "Vendor expense" &&
                        vendor.map((item, index) => (
                          <option key={index} value={item.name}>
                            {item.name}
                          </option>
                        ))}
                    </select>
                    <label className={updateData.paidto ? "filled" : ""}>
                      {/* Optionally you can add custom label text */}
                    </label>
                  </div>


                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">



                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      disabled
                      value={updateData.date}
                      // onChange={handleDateChange}
                      required
                    />
                    <label className={updateData.date ? "filled" : ""}>
                      Date
                    </label>
                  </div>



                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.amount}
                      disabled
                      onChange={(e) =>
                        setUpdateData({ ...updateData, amount: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.amount ? "filled" : ""}>
                      Amount
                    </label>
                  </div>

                  <div className="floating-label">
                    <select
                      className="form-control"
                      value={updateData.paytype}
                      disabled
                      onChange={(e) =>
                        setUpdateData({ ...updateData, paytype: e.target.value })
                      }
                    >
                      <option value="">Select Paytype </option>
                      {paymenttype.map((item, index) => (
                        <option key={index} value={item.Payment_type}>
                          {item.Payment_type}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.paytype ? "filled" : ""}></label>
                  </div>
                </div>
              </div>
              <div className="floating-label col-lg-12">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  disabled
                  value={updateData.notes}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, notes: e.target.value })
                  }
                  required
                />
                <label className={updateData.notes ? "filled" : ""}>
                  Notes
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShowModal(false)}
            >
              Cancel
            </Button>

          </Modal.Footer>
        </Modal>


        {/* ----------------delete */}

        <Modal
          className="modal"
          show={deleteShowModals}
          onHide={handleCloseModal}
        >
          <Modal.Header>
            <p id="modeti">Are you sure you want to Delete?</p>
          </Modal.Header>
          <Modal.Body>
            <label className="form-label d-flex">
              <h5 className="mx-1">Paid To :</h5> <h5>{getdeletename} </h5>
            </label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
        {/* _------------------------------pagination button -------------------------------- */}

        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {state.pageIndex + 1} of {pageCount}
              </span>
            </div>
            <div className="col-lg-5">
              <div className="mt-3 pb-5">
                <nav>
                  <ul className="pagination justify-content-center">
                    {createPagination()} {/* Pagination buttons */}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* ---------------------------------------end ---------------------------------- */}
      </div>
    </>
  );
}

export default Expenselist;
